import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=2d1b8378&lang=pug&"
import script from "./Node.vue?vue&type=script&lang=js&"
export * from "./Node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports